module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedExtraLight.3d1fecb.woff2";